(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  define('app/views/pipods/pipodItem',['marionette', 'templates', 'app/views/songs/song', 'app/helpers/timeFormatHelper'], function(Marionette, templates, SongView) {
    'use strict';
    var PipodItemView;
    return PipodItemView = (function(_super) {
      __extends(PipodItemView, _super);

      function PipodItemView() {
        return PipodItemView.__super__.constructor.apply(this, arguments);
      }

      PipodItemView.prototype.tagName = 'li';

      PipodItemView.prototype.className = 'pipod-item';

      PipodItemView.prototype.template = templates.pipods.pipodItem;

      PipodItemView.prototype.regions = {
        'currentSong': '[data-current-song]'
      };

      PipodItemView.prototype.modelEvents = {
        'change:playing_since': 'render'
      };

      PipodItemView.prototype.events = {
        'click': function() {
          return NowPlaying.navigate('venues/' + this.model.get('mac_address'), {
            trigger: true
          });
        }
      };

      PipodItemView.prototype.initialize = function(options) {
        this.pipod = this.model;
        return this.song = this.pipod.nowPlaying;
      };

      PipodItemView.prototype.onRender = function() {
        this.songView = new SongView({
          model: this.song
        });
        this.listenTo(this.songView, 'finished', (function(_this) {
          return function() {
            return setTimeout(function() {
              return _this.pipod.fetch();
            }, 1000);
          };
        })(this));
        return this.currentSong.show(this.songView);
      };

      PipodItemView.prototype.onBeforeDestroy = function() {
        return clearInterval(this.updateTimer);
      };

      return PipodItemView;

    })(Marionette.LayoutView);
  });

}).call(this);

//# sourceMappingURL=pipodItem.js.map
;
